@if (label) {
  <div style="display: flex; justify-content: space-between">
    <p class="font-weight-bold ml-4">{{ label }}</p>
    @if (enableSignOrder) {
      <div style="display: flex">
        <p class="font-weight-bold ml-4">{{ 'signrequest.sign_order' | translate}} </p>
        <span style="margin-left: 5px">{{parallel ? ('signrequest.parallel' | translate) : ('signrequest.sequential' | translate)}} </span>
      </div>
    }
  </div>
}
<ul class="recipients-list pl-4">
  @for (recipient of recipients; track recipient) {
    <li [ngClass]="{ active: recipient.email === selected?.email || showOpen }"
      class="p-3 border border-primary primary rounded"  >
      <div (click)="toggle(recipient) && !recipient.privacyProtected" [tooltip]="recipient.privacyProtected ? '*****' : recipient.email" class="recipient-header">
        {{ recipient.name }}
      </div>
      <div class="recipient-info show">
        <dl class="row mb-0" >
          @if (recipient.signatoryRole !== 'CC') {
            <dt class="col-5">{{ 'signrequest.signatory_role' | translate}}</dt>
            <dd class="col-7">{{  'roles.role_' + recipient.signatoryRole.toLowerCase() | translate }}</dd>
          }
          @if (!recipient.privacyProtected) {
            <dt class="col-5">{{ 'signrequest.email_address' | translate }}</dt>
            <dd class="col-7">{{ recipient.email }}</dd>
            @if (recipient.signatoryRole !== 'CC') {
              <dt class="col-5">{{ 'contacts.phone' | translate }}</dt>
            }
            @if (recipient.signatoryRole !== 'CC') {
              <dd class="col-7">{{ recipient.phone ? recipient.phone : 'N/A' }}</dd>
            }
          }
          @if (recipient.signatoryRole !== 'CC') {
            @if (getAuthMethodsByType(recipient, 'PREVIEW').length && getAuthMethodsByType(recipient, 'PREVIEW'); as AM) {
              <dt class="col-5">{{ 'workflow.authentication_preview' | translate }}</dt>
              <dd class="col-7">
                @for (am of AM; track am) {
                  <span class="badge badge-primary rounded-border">{{ 'signrequest.am.' + am.type | translate }}</span>
                }
              </dd>
            }
            @if (getAuthMethodsByType(recipient, 'AFTERVIEW').length && getAuthMethodsByType(recipient, 'AFTERVIEW'); as AM) {
              <dt class="col-5">{{ 'workflow.authentication' | translate }}</dt>
              <dd class="col-7">
                @for (am of AM; track am) {
                  <span class="badge badge-primary rounded-border">{{ 'signrequest.am.' + am.type | translate }}</span>
                }
              </dd>
            }
          }
          <dt class="col-5">{{ 'signrequest.language' | translate }}</dt>
          <dd class="col-7">{{ 'locale.' + recipient.locale | translate }}</dd>
        </dl>
        @if (recipient.signatoryRole === 'SIGN' || recipient.signatoryRole === 'ACCEPTANCE') {
          @if (canChange) {
            <div>
              <div class="checkbox c-checkbox pr-3">
                <label>
                  <input (change)="toggleDisableEmail(recipient)"
                    [checked]="!recipient.disableEmail"
                    type="checkbox">
                    <span class="fa fa-check"></span> {{ 'signrequest.receive_document' | translate }}
                  </label>
                </div>
              </div>
              <div>
                <div class="checkbox c-checkbox pr-3">
                  <label>
                    <input (change)="toggleDisableInvitation(recipient)"
                      [checked]="!recipient.disableInvitation"
                      type="checkbox">
                      <span class="fa fa-check"></span> {{ 'signrequest.receive_invitation' | translate }}
                    </label>
                  </div>
                </div>
              } @else {
                <div>
                  <div>
                    <em [ngClass]="!recipient.disableEmail ? 'fa-check-square text-success' : 'fa-square text-muted'" class="fas fa-fw fa-lg"></em> {{ 'signrequest.receive_document' | translate }}
                  </div>
                  <div>
                    <em [ngClass]="!recipient.disableInvitation ? 'fa-check-square text-success' : 'fa-square text-muted'" class="fas fa-fw fa-lg"></em> {{ 'signrequest.receive_invitation' | translate }}
                  </div>
                </div>
              }
            }
          </div>
        </li>
      }
    </ul>
